import { render, staticRenderFns } from "./PopupBoardWrite.vue?vue&type=template&id=51643c1e"
import script from "./PopupBoardWrite.vue?vue&type=script&lang=js"
export * from "./PopupBoardWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports